var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\r\n<p>Specify which branch licenses will be renewed along with the principal license.</p>\r\n\r\n<div class=\"branch-licenses-container\"></div>";
},"useData":true});